var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAzulComunicacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.001,
    height: 72,
    viewBox: "0 0 72.001 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16943",
    "data-name": "Grupo 16943",
    transform: "translate(-759 -367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclus\\xE3o_7",
    "data-name": "Exclus\\xE3o 7",
    d: "M14307-2488a35.77,35.77,0,0,1-14.013-2.829,35.878,35.878,0,0,1-11.443-7.716,35.891,35.891,0,0,1-7.714-11.443A35.783,35.783,0,0,1,14271-2524a35.787,35.787,0,0,1,2.829-14.014,35.886,35.886,0,0,1,7.714-11.443,35.869,35.869,0,0,1,11.443-7.715A35.774,35.774,0,0,1,14307-2560a35.77,35.77,0,0,1,14.012,2.829,35.886,35.886,0,0,1,11.444,7.715,35.891,35.891,0,0,1,7.715,11.443A35.788,35.788,0,0,1,14343-2524a35.783,35.783,0,0,1-2.829,14.012,35.9,35.9,0,0,1-7.715,11.443,35.9,35.9,0,0,1-11.444,7.716A35.773,35.773,0,0,1,14307-2488Zm-12.886-51.017a3.949,3.949,0,0,0-3.945,3.945v16.979a3.948,3.948,0,0,0,3.945,3.942h6.119a.263.263,0,0,1,.263.263v6.688a1.844,1.844,0,0,0,1.138,1.7,1.827,1.827,0,0,0,.7.14,1.827,1.827,0,0,0,1.3-.539l8.171-8.175a.281.281,0,0,1,.188-.076h7.89a3.948,3.948,0,0,0,3.942-3.945v-16.979a3.9,3.9,0,0,0-1.156-2.79,3.92,3.92,0,0,0-2.793-1.156Zm8.226,32.079a.255.255,0,0,1-.1-.021.265.265,0,0,1-.162-.245v-6.685a1.842,1.842,0,0,0-1.84-1.839h-6.122a2.369,2.369,0,0,1-2.369-2.365v-16.979a2.37,2.37,0,0,1,2.369-2.365h25.766a2.369,2.369,0,0,1,2.368,2.365v16.979a2.369,2.369,0,0,1-2.368,2.365h-7.9a1.841,1.841,0,0,0-1.289.525l-8.164,8.186A.26.26,0,0,1,14302.341-2506.938Z",
    transform: "translate(-13512 2927)",
    fill: "#4663ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202_-_Contorno",
    "data-name": "Caminho 202 - Contorno",
    d: "M36,2A34.009,34.009,0,0,0,22.766,67.329,34.009,34.009,0,0,0,49.234,4.671,33.785,33.785,0,0,0,36,2m0-2A36,36,0,1,1,0,36,36,36,0,0,1,36,0Z",
    transform: "translate(759 367)",
    fill: "#4663ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAzulComunicacao);
export default __webpack_public_path__ + "static/media/ico-azul-comunicacao.c9a22bc4e0a073b6ecb32eb54cf459df.svg";
export { ForwardRef as ReactComponent };